import { ReactNode } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  updateApplicantProfile,
  updateCurrentUserWith,
} from 'store/main/ducks/currentUser';
import { dismissResumeDBLoggedOut } from 'utils/resumeDatabase';

const ResumeDatabaseResponseContainer = ({
  children,
}: {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: (arg0: { dismiss: (...args: Array<any>) => any }) => ReactNode;
}) => {
  const { currentUser } = useSelector((state) => ({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentUser' does not exist on type 'Def... Remove this comment to see the full error message
    currentUser: state.currentUser,
  }));
  const dispatch = useDispatch();

  const dismiss = () => {
    if (currentUser.id) {
      dispatch(
        updateApplicantProfile({
          isRecruitable: false,
        })
      );
    } else {
      dismissResumeDBLoggedOut();
      dispatch(
        updateCurrentUserWith({
          isRecruitable: false,
        })
      );
    }
  };

  return children({
    dismiss,
  });
};

export default ResumeDatabaseResponseContainer;
